<template>
  <section id="bases">
    <div id="breadcrumbs">
      <div class="bg-light py-3">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-0 text-left">
              <router-link to="/">Home</router-link>
              <span class="mx-2 mb-0">/</span>
              <strong class="text-black">Bases</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- #breadcrumbs -->
    <div>
      <div class="container">
        <div class="row">
          <div class="col-md-12 mb-0">
            <h3 class="text-center mt-4">Bases #Los7demoi</h3>
            <p class="text-base">
              1. Podrán suscribirse personas mayores de 18 años residentes en la
              República Mexicana.
            </p>
            <p class="text-base">
              2. Participan cualquier suscripción el 15 de abril de 2021.
            </p>
            <p class="text-base">
              3. Las suscripciones nuevas que se registren hasta el 15 de abril
              recibirán como primer ejemplar la revista de abril.
            </p>
            <p class="text-base">
              4. Para poder realizar el examen de conocimientos, el suscriptor
              activo deberá registrarse por medio de un correo electrónico el 23
              de abril de 2021.
            </p>
            <p class="text-base">
              5. Toda persona que se suscriba del 1 al 20 de abril de 2021 podrá
              ser ganador de un premio de aniversario, según los siguientes
              números:
            </p>
            <ul>
              <li class="text-base">
                Cada 10 suscriptores: 1 libro de Michelle Obama (se otorgarán 15
                libros cada diez suscriptores que respondan de manera correcta y
                en el menor tiempo posible el examen de conocimiento).
              </li>
              <li class="text-base">
                Cada 50 suscriptores: 1 kit Martha Debayle Hair Tech (se
                otorgarán 10 kit’s cada 50 suscriptores que respondan de manera
                correcta y en el menor tiempo posible el examen de
                conocimiento).
              </li>
              <li class="text-base">
                Cada 100 suscriptores: 1 tarjeta de regalo por $3000 de la marca
                de ropa Ivonne. (se otorgarán 10 tarjetas cada 100 suscriptores
                que respondan de manera correcta y en el menor tiempo posible el
                examen de conocimiento).
              </li>
            </ul>

            <p class="text-base">
              6. El turno de participación en la dinámica de alegrías de
              aniversario será asignada de manera automática por el sistema de
              cobro.
            </p>
            <p class="text-base">
              7. Los regalos para la dinámica de aniversario se entregarán hasta
              agotar existencias.
            </p>
            <p class="text-base">
              8. El envío de premios se realizará después del 25 de abril.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "bases",
};
</script>

<style scoped>
.text-base {
  text-align: left;
  line-height: 3.5 !important;
}
</style>